import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import ViewEditProduct from "../../components/product-information/product-view-edit";
import { storeViewAction } from "../../redux/actions/store-action";
import StoreCreateViewEdit from "../../components/store-information/create-edit-view-store";
const ViewStore = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [store, setStore] = useState({});
  const [loading, setLoading] = useState(true);
  const [storeData, setStoreData] = useState({
    address: {},
    personal: {},
    firm: {},
    agreement: {},
    payment: {},
    drug: {},
  });
  useEffect(() => {
    dispatch(storeViewAction(id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    const store = data?.data?.[0];
    const latestPayment = store?.payment?.[0] ?? {};
    const paymentFields = {
      transaction_id: latestPayment.transaction_id,
      payment_method: latestPayment.payment_method,
      payment_amount: latestPayment.payment_amount,
      payment_status: latestPayment.payment_status,
      payment_remarks: latestPayment.payment_remarks,
      payment_receipt: latestPayment.payment_receipt,
      payment_date: latestPayment.payment_date,
      payer_name_as_per_bank: latestPayment.payer_name_as_per_bank,
      payer_bank_name: latestPayment.payer_bank_name,
      payer_bank_account_no: latestPayment.payer_bank_account_no,
    };
    setStoreData({
      address: store,
      personal: store,
      firm: store,
      agreement: store,
      payment: { ...store, ...paymentFields },
      drug: store,
    });
    setStore(store);
  };
  const onError = (data) => {
    loading(false);
  };
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
        
        backBtn={true}
          page="view"
          title={"View Store-Information"}
          title1={store?.store_id}
          view={true}
          onclkEditFn={() => navigate(`/edit-store/${id}`)}
        >
          <StoreCreateViewEdit
            disabled={true}
            store={store}
            storeData={storeData}
            setStoreData={setStoreData}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default ViewStore;
